const map = {
  subscription: 'Assinaturas',
  video_watch: 'Conteúdo',
  purchase: 'Compras',
  purchase_refund: 'Estorno de compras',
}

export default str => map[str] || str
